import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import { useNavigate, useParams } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import { path } from '../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import Translator from '../../../../../components/helpers/Translator';
import _ from 'lodash';

export default function GoToMarker() {
  const { moduleBridgeHex, view, filtersHex } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userMarkTaskID = useSelector(
    (state) => state.currentPage?.options?.userMark
  );
  const tasks = useSelector((state) => state.currentPage?.tasks);

  const handleGoToMarker = useCallback(() => {
    if (userMarkTaskID && tasks !== undefined) {
      dispatch(currentPageAction.change('goToMark', true, true));
      navigate(
        path({
          name: 'user_module_correctiveActions_task_list',
          params: {
            moduleBridgeHex,
            view,
            page:
              parseInt(_.findKey(tasks, (p) => p.includes(userMarkTaskID))) + 1,
            filtersHex,
          },
        })
      );
    }
  }, [userMarkTaskID, tasks, moduleBridgeHex, view]);

  return (
    <li
      title={ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="go.marker.page" />
      )}
      className={`pointer ${
        userMarkTaskID !== undefined &&
        userMarkTaskID !== null &&
        tasks !== undefined
          ? ''
          : 'off'
      }`}
    >
      <AppRemixIcon
        icon="map-pin-user"
        size={20}
        onClick={() => handleGoToMarker()}
      />
    </li>
  );
}
